<!-- <div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2" *ngIf="!bookingInit || !copyLoaded || !pricingInit">
  <div class="loader-container">
    <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div>
  </div>
</div> -->

<div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp"
  *ngIf="bookingInit && copyLoaded && pricingInit">

  <div [class.formHidden]="showChallengeShopper">

    <app-language-selector></app-language-selector>

    <button id="collection-back" type="button" class="btn btn-link hidden-sm hidden-xs back-btn"
      *ngIf="bookingType !== 'amend'" (click)="goPanelBack()">
      <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkBack'+selectedLanguage]}}
    </button>
    <button id="add-payment-back" type="button" class="btn btn-link back-btn" *ngIf="bookingType === 'amend'"
      (click)="cancelAmend()">
      <i class="icon">chevron_left</i>
      {{appCopy.panelHeader['linkCancel'+selectedLanguage]}}
    </button>

    <ng-template [ngIf]="bookingState.bookingDetails.bookingAmendType === 'refund'" [ngIfElse]="notRefund">
      <h1 class="text-dark-blue h1">{{appCopy.panelHeader['titleRefund'+selectedLanguage]}}</h1>
    </ng-template>

    <ng-template #notRefund>
      <h1 class="text-dark-blue h1">{{appCopy.panelHeader['title'+selectedLanguage]}}</h1>
    </ng-template>

    <p class="margin-bottom-8 text-dark-blue" [ngClass]="{
          'margin-bottom-32': bookingType === 'amend'
        }">{{appCopy.panelHeader['content'+selectedLanguage]}}</p>

    <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="margin-bottom-8 text-dark-green"
      [ngClass]="{'margin-bottom-32': collectionDiff < 2}">
      <i class="icon icon-cut-off-checkmark"></i>
      <ng-container *ngIf="collectionDiff > 12 else less12">
        {{appCopy.panelHeader['cutOfTiming'+selectedLanguage]}}
        {{cutOffTimeWindowDate | date:'MMMM d' :'' : languageCode}} {{appCopy.panelHeader['at'+selectedLanguage]}}
        {{cutOffTimeWindowTime | date:'hh:mm a' :'' : languageCode}}
      </ng-container>
      <ng-template #less12>
        {{appCopy.panelHeader['cutOfTimingLess12'+selectedLanguage]}}
      </ng-template>
    </p>

    <p *ngIf="bookingType !== 'amend' && amendCutOffTimeWindowDate && collectionDiff > 2"
      class="margin-bottom-32 text-dark-green">
      <i class="icon icon-cut-off-checkmark"></i>
      {{appCopy.panelHeader['amendCutOfTiming'+selectedLanguage]}}
      {{amendCutOffTimeWindowDate | date:'MMMM d' :'' : languageCode}} {{appCopy.panelHeader['at'+selectedLanguage]}}
      {{amendCutOffTimeWindowTime | date:'hh:mm a' :'' : languageCode}}
    </p>

    <div class="flex-always flex--space-between margin-bottom-16">
      <h5 *ngIf="bookingAmendSection === 'booker' || bookingAmendSection === '' && price.totalPrice.majorAmount > 0"
        class="margin-top-0 margin-bottom-0 text-dark-blue">{{appCopy.panelHeader['yourDetailsTitle'+selectedLanguage]}}
      </h5>
    </div>
    <!-- miles-and-more -->
    <app-miles-and-more-pay
      *ngIf="(milesLoaded === 'success' || milesLoaded === 'low_price' || milesLoaded === 'low_miles') && milesReducer.canPayWithMiles && milesReducer.isUserLoggedIn"
      [appCopy]="appCopy" [selectedLanguage]="selectedLanguage">
    </app-miles-and-more-pay>
    <div
      *ngIf="!milesReducer.isUserLoggedIn && canDoMilesLogin && price.totalPrice.majorAmount > 0 && bookingState.bookingDetails.bookingAmendType !== 'refund' && bookingAmendSection !== 'booker' && milesLoaded !== 'success'"
      class="margin-bottom-8 ng-star-inserted">
      <!-- <div class="col-lg-6 col-md-6 margin-bottom-16"></div> -->
      <div id="miles-section" class="col-lg-12 col-md-12 margin-bottom-16 miles-section">
        <div class="flex-always miles-header flex--wrap flex--space-between">
          <span class="title text-dark-blue">{{appCopy.panelHeader['spenMilesTitle'+selectedLanguage]}}</span>
          <span>
            <img class="miles-logo" src="./images/Miles-More-Logo.png" alt="Miles-More-Logo" />
          </span>
        </div>
        <button (click)="milesLoginRedirect()" type="button" class="btn btn-mile-more ng-star-inserted">
          {{appCopy.panelHeader['milesLoginBtn'+selectedLanguage]}}
          <div class="loader-container-btn" *ngIf="milesLoaded === 'loading'">
            <div class="loader loader--gray">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
        </button>
        <!-- only in case of new booking -->
        <!-- divider -->
        <div class='textDivider'>
          <span class='divider'></span>
          <span class='text text-dark-blue'>{{appCopy.panelHeader['orText'+selectedLanguage]}}</span>
        </div>
        <!-- inline form for miles earning -->
        <div *ngIf="!saveDMilesServiceCard">
          <div class="col-lg-12 col-md-12 mb-sm">
            <div class="row">
              <div class="col-sm-10">
                <span class="text-dark-blue">{{appCopy.panelHeader['earnMilesLabel'+selectedLanguage]}}</span>
              </div>
              <div class="col-sm-2">
                <p>{{getExpectMilesEarningAmount() + appCopy.panelHeader['milesText'+selectedLanguage]}}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 mb-lg">
            <!-- if no miles service card  -->
            <div class="row">
              <div class="col-sm-9">
                <div class="form-group margin-bottom-0">
                  <input [pattern]="milesServiceCardPattern" class="form-control"
                    [ngClass]="{ 'has-error' : milesCard.invalid && milesCard.dirty }" id="milesCard" name="milesCard"
                    type="text" #milesCard="ngModel" ngModel alert-caps-lock appCheckEmpty>
                  <label class="control-label"
                    for="milesCard">{{appCopy.panelHeader['milesCSlabel'+selectedLanguage]}}</label>
                  <i class="icon control-validation-state"></i>
                </div>
              </div>
              <div class="col-sm-3">
                <button (click)="saveMilesServiceCard(milesCard.value)" [ngClass]="{'Buttonloading' : showLoginLoader }"
                  class="btn btn-block btn-purple btn-lg" type="button"
                  [disabled]="milesCard.value === '' || showLoginLoader">
                  <span style="color: inherit;"
                    *ngIf="!showLoginLoader">{{appCopy.panelHeader['earnText'+selectedLanguage]}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- if added miles service card -->
        <div *ngIf="saveDMilesServiceCard" class="col-lg-12 col-md-12 mb-lg">
          <div class="row">
            <div class="col-sm-9">
              <span class="miles_earn"
                [innerHTML]="appCopy.panelHeader['milesEarnedMessage'+selectedLanguage].replace('{cardNumber}', saveDMilesServiceCard).replace('{earnedMiles}', getExpectMilesEarningAmount())">
                {{saveDMilesServiceCard}} will earn <span class='reward'>{{getExpectMilesEarningAmount()}}</span> award
                miles
              </span>
            </div>
            <div [align]="'right'" class="col-sm-3">
              <span class="text-dark-blue">
                <button (click)="removeMilesServiceCard()" class="btn btn-text"><i class="icon">cross</i></button>
              </span>
            </div>
          </div>
        </div>
        <div *ngIf="bookingType !== 'amend'" class="flex-always flex--wrap mile-promo flex--space-between">
          <span class="text-dark-blue">{{appCopy.panelHeader['milesPromoTitle'+selectedLanguage]}}</span>
          <button (click)="scrollToPromoField()"
            class="btn ng-star-inserted promo-btn">{{appCopy.panelHeader['milesPromoBtn'+selectedLanguage]}}</button>
        </div>
      </div>
    </div>
    <!-- miles-and-more -->

    <div class="panel panelPaymentOption"
      *ngIf="bookingType !== 'amend' && bookingAmendSection !== 'booker' && price.totalPrice.majorAmount > 0">
      <h5 class="checkoutTitle">{{appCopy.panelHeader['checkoutExpressTitle'+selectedLanguage]}}</h5>
      <form #termsFormExpresscheckout="ngForm" name="termsFormExpresscheckout" class="termsFormExpresscheckout" ng
        novalidate *ngIf="bookingType !== 'amend'">
        <ul class="list-group margin-bottom-0">
          <li style="display: none;" class="list-group-item mb-5">
            <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
              <input type="checkbox"
                [ngClass]="{ 'has-error' : DataSharingAllowedCheckoutExpress.dirty && DataSharingAllowedCheckoutExpress.invalid }"
                name="dataSharingAllowedCheckoutExpress" id="dataSharingAllowedCheckoutExpress"
                #DataSharingAllowedCheckoutExpress="ngModel" [ngModel]='true' required (change)="iUnderstand($event)">
              <label for="dataSharingAllowedCheckoutExpress" class="text-caption">
                {{appCopy.panelHeader['dataSharingAllowedCheckLabel'+selectedLanguage]}}
              </label>
            </div>
            <p class="help-block text-danger"
              *ngIf="DataSharingAllowedCheckoutExpress.dirty && DataSharingAllowedCheckoutExpress.invalid">
              {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
            </p>
          </li>

          <ng-container *ngIf="!showHasSmsMarketingEnrolmentForExpressCheckout">
            <li class="list-group-item mb-5" *ngIf="!customerOptIn">
              <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                <input type="checkbox" name="hasSmsMarketingEnrolmentForExpress"
                  id="hasSmsMarketingEnrolmentForExpressCheckout" #HasSmsMarketingEnrolmentForExpressCheckout="ngModel"
                  [(ngModel)]='hasSmsMarketingEnrolmentForExpressCheckout'>
                <label for="hasSmsMarketingEnrolmentForExpressCheckout" class="text-caption">
                  <span>
                    <b>{{appCopy.panelHeader['hasSmsMarketingEnrolmentCheckLabel'+selectedLanguage]}}</b>
                    <span>{{appCopy.panelHeader['hasSmsMarketingEnrolmentChecMsg'+selectedLanguage]}}</span>
                  </span>
                </label>
              </div>
            </li>
          </ng-container>


          <li style="display: none;" class="list-group-item mb-5" *ngIf="customsInspection">
            <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
              <input type="checkbox"
                [ngClass]="{ 'has-error' : CustomsForInspectionCheckoutExpress.dirty && CustomsForInspectionCheckoutExpress.invalid }"
                name="customsForInspectionCheckoutExpress" id="customsForInspectionCheckoutExpress"
                #CustomsForInspectionCheckoutExpress="ngModel" [ngModel]='true' required
                (change)="customsForInspection($event)">
              <label for="customsForInspectionCheckoutExpress" class="text-caption"
                [innerHTML]="appCopy.panelHeader['customsForInspection'+selectedLanguage]"></label>
            </div>
            <p class="help-block text-danger"
              *ngIf="CustomsForInspectionCheckoutExpress.dirty && CustomsForInspectionCheckoutExpress.invalid">
              {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
            </p>
          </li>
          <li *ngIf="ccdCheckbox" style="display: none;" class="list-group-item mb-5 check-customVerification">
            <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
              <input type="checkbox"
                [ngClass]="{ 'has-error' : customVerificationCheckoutExpress.dirty && customVerificationCheckoutExpress.invalid }"
                name="customVerificationCheckoutExpress" id="customVerificationCheckoutExpress"
                #customVerificationCheckoutExpress="ngModel" [ngModel]='true' required (change)="iVerify($event)">
              <label for="customVerificationCheckoutExpress" class="text-caption"
                [innerHTML]="appCopy.panelHeader['customVerificationCheckLabel'+selectedLanguage]"></label>
            </div>
            <p class="help-block text-danger"
              *ngIf="customVerificationCheckoutExpress.dirty && customVerificationCheckoutExpress.invalid">
              {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
            </p>
          </li>
          <li *ngIf="emiratesSkywards" style="display: none;" class="list-group-item mb-5 check-customVerification">
            <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
              <input type="checkbox"
                [ngClass]="{ 'has-error' : skywardsMembershipCheckoutExpress.dirty && skywardsMembershipCheckoutExpress.invalid }"
                name="skywardsMembershipCheckoutExpress" id="skywardsMembershipCheckoutExpress"
                #skywardsMembershipCheckoutExpress="ngModel" [ngModel]='true' (change)="skywardsCheck($event)">
              <label for="skywardsMembershipCheckoutExpress" class="text-caption"
                [innerHTML]="appCopy.panelHeader['skywardsMembershipLable'+selectedLanguage]"></label>
            </div>
          </li>
        </ul>
      </form>
      <div class="paymentButtons">
        <span class="googlePayWrapper" *ngIf="paymentOptionsAvailable.gpay">
          <p id="googlepayValidation" name="googlepayValidation">Please use google pay button for your payment</p>
          <p id="googlepayRefile" name="googlepayRefile">You have update booking details please use google pay again.
          </p>
          <div class="g-pay amount-section">
            <google-pay-button
              [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'gPayBtnStandard' : 'gPayBtnAmend'"
              [environment]="env === 'prod' ? 'PRODUCTION' : 'TEST'" buttonType="plain" buttonColor="black"
              buttonSizeMode="fill" (loadpaymentdata)="onLoadPaymentData($event)" [paymentRequest]="paymentRequest"
              [paymentAuthorizedCallback]="onPaymentAuthorizedData" (error)="onError($event)"
              [clickCallback]="onPressButton" value="Pay">
            </google-pay-button>
          </div>
          <!-- <div
            style="position: absolute; position: absolute; right: -8px;left: -8px; background-color: #ffffff8c; bottom: 0; top: 0;display: flex;"
            class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg style="left:-100px;" class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div> -->
        </span>
        <span *ngIf="paymentOptionsAvailable.apple">
          <app-apple-pay #applePay (handleApplePay)="handleApplePay($event)" [isD2dService]="isD2dService"
            [showLoader]="showLoader" [disablePayButton]="disableBook || !phoneNumberValid || virtualBags===0"
            [bookingState]="bookingState" [paymenttype]="paymenttype" [price]="price" [appCopy]="appCopy"
            [selectedLanguage]="selectedLanguage">
          </app-apple-pay>
        </span>
      </div>
    </div>

    <app-booker-form #bookerForm [currentBooking]="currentBooking" [bookingState]="bookingState" [user]="user"
      (validatePhoneNumberParent)="handleValidatePhoneNumber($event)" (emailInputChange)="handleEmailInputChange()"
      [appCopy]='appCopy' [selectedLanguage]='selectedLanguage' [formData]="upsellFormData">
    </app-booker-form>

    <form #termsForm="ngForm" class="termForm" name="termsForm" ng novalidate *ngIf="bookingType !== 'amend'">
      <ul class="list-group margin-bottom-0">
        <li [hidden]="true" style="display: none;" class="list-group-item mb-5">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : DataSharingAllowed.dirty && DataSharingAllowed.invalid }"
              name="dataSharingAllowed" id="dataSharingAllowed" #DataSharingAllowed="ngModel" [ngModel]='true' required
              (change)="iUnderstand($event)">
            <label for="dataSharingAllowed" class="text-caption">
              {{appCopy.panelHeader['dataSharingAllowedCheckLabel'+selectedLanguage]}}
            </label>
          </div>
          <p class="help-block text-danger" *ngIf="DataSharingAllowed.dirty && DataSharingAllowed.invalid">
            {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
          </p>
        </li>

        <li class="list-group-item mb-5" *ngIf="customsInspection" style="display: none;">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox"
              [ngClass]="{ 'has-error' : CustomsForInspection.dirty && CustomsForInspection.invalid }"
              name="customsForInspection" id="customsForInspection" #CustomsForInspection="ngModel" [ngModel]='true'
              required (change)="customsForInspection($event)">
            <label for="customsForInspection" class="text-caption"
              [innerHTML]="appCopy.panelHeader['customsForInspection'+selectedLanguage]"></label>
          </div>
          <p class="help-block text-danger" *ngIf="CustomsForInspection.dirty && CustomsForInspection.invalid">
            {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
          </p>
        </li>
        <li *ngIf="ccdCheckbox" style="display: none;" class="list-group-item mb-5 check-customVerification">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : customVerification.dirty && customVerification.invalid }"
              name="customVerification" id="customVerification" #customVerification="ngModel" [ngModel]='true' required
              (change)="iVerify($event)">
            <label for="customVerification" class="text-caption"
              [innerHTML]="appCopy.panelHeader['customVerificationCheckLabel'+selectedLanguage]"></label>
          </div>
          <p class="help-block text-danger" *ngIf="customVerification.dirty && customVerification.invalid">
            {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
          </p>
        </li>
        <li *ngIf="emiratesSkywards" style="display: none;" class="list-group-item mb-5 check-customVerification">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : skywardsMembership.dirty && skywardsMembership.invalid }"
              name="skywardsMembership" id="skywardsMembership" #skywardsMembership="ngModel" [ngModel]='true'
              (change)="skywardsCheck($event)">
            <label for="skywardsMembership" class="text-caption"
              [innerHTML]="appCopy.panelHeader['skywardsMembershipLable'+selectedLanguage]"></label>
          </div>
        </li>
      </ul>
    </form>

    <!-- amend booker/contact details-->
    <button id="formBookerAmend-submit" type="button" class="btn btn-primary btn-block margin-top-12" value="Pay"
      *ngIf="bookingType === 'amend' && bookingAmendSection === 'booker'" (click)="handleBookerAmend()"
      [disabled]="showAmendLoader">

      <div class="loader-container-btn" *ngIf="showAmendLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{appCopy.panelHeader['buttonSaveDetails'+selectedLanguage]}}
    </button>

    <!-- pay by invoice checkbox and hr -->
    <!-- <div class="form-group" *ngIf="showInvoice">
      <div class="checkbox checkbox--default checkbox--small">
        <input type="checkbox" name="payByInvoice" id="payByInvoice" (change)="togglePayByInvoice($event)">
        <label for="payByInvoice"
          class="text-muted">{{appCopy.panelHeader['payByInvoiceCheckLabel'+selectedLanguage]}}</label>
      </div>
    </div>
    <hr class="margin-top-16 margin-bottom-16" *ngIf="showInvoice"> -->

    <!-- <div class="alert flex flex--space-between alert-info-light" *ngIf="hasPriceDifference && bookingType === 'amend'">
      <p>Price difference to be paid: £{{ priceDifferenceAmout }}</p>
    </div> -->

    <!-- <div *ngIf="showOverridePayment"
      class="checkbox checkbox--default checkbox--small margin-bottom-16">
      <input type="checkbox"
        name="overridePayment"
        id="overridePayment"
        [(ngModel)]="overridePayment">
      <label for="overridePayment" class="text-caption">Do not charge the customer for this amendment</label>
    </div> -->

    <div class="panel amendPyment-panel"
      *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker' && bookingState.bookingDetails.bookingAmendType !== 'refund'">


      <div class="payment-option googlePay">
        <google-pay-button
          [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'gPayBtnStandard' : 'gPayBtnAmend'"
          [environment]="env === 'prod' ? 'PRODUCTION' : 'TEST'" buttonType="plain" buttonColor="black"
          buttonSizeMode="fill" (loadpaymentdata)="onLoadPaymentData($event)" [paymentRequest]="paymentRequest"
          [paymentAuthorizedCallback]="onPaymentAuthorizedData" (error)="onError($event)"
          [clickCallback]="onPressButton" value="Pay">
        </google-pay-button>

      </div>
      <div class="payment-option" *ngIf="paymentOptionsAvailable.apple">
        <app-apple-pay #applePay (handleApplePay)="handleApplePay($event)" [isD2dService]="isD2dService"
          [showLoader]="showLoader" [disablePayButton]="disableBook || !phoneNumberValid || virtualBags===0"
          [bookingState]="bookingState" [paymenttype]="paymenttype" [price]="price" [appCopy]="appCopy"
          [bookingAmendType]="bookingState.bookingDetails.bookingAmendType" [selectedLanguage]="selectedLanguage">
        </app-apple-pay>

      </div>
    </div>


    <div class="reveal" *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker'">

      <div class="reveal__content">
        <div class="panel-body">
          <app-price-breakdown [appCopy]="appCopy" [selectedLanguage]="selectedLanguage" [price]="price"
            [timeslot]="bookingState.bookingDetails.timeslot" [amendType]="bookingState.bookingDetails.bookingAmendType"
            [premiumSurcharge]="premiumSurcharge">
          </app-price-breakdown>
        </div>
        <hr class="margin-top-0 margin-bottom-0">
      </div>

      <div class="reveal__toggle panel-body" appRevealToggle>
        <div class="flex-always flex--space-between">
          <div>
            <p>{{appCopy.panelHeader['total'+selectedLanguage]}}</p>
            <a class="link reveal__closed text-600"
              href="javascript:void(0)">{{appCopy.panelHeader['viewPriceBreakdown'+selectedLanguage]}}</a>
            <a class="link reveal__open"
              href="javascript:void(0)">{{appCopy.panelHeader['hidePriceBreakdown'+selectedLanguage]}}</a>
          </div>
          <p class="total-price" *ngIf="price.priceHistory.majorPriceDifference !== 0">
            <span *ngIf="bookingState.bookingDetails.bookingAmendType === 'payment'">+ </span>
            <span *ngIf="bookingState.bookingDetails.bookingAmendType === 'refund'">- </span>
            {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
            price.priceHistory.majorAmount }}
          </p>
        </div>
      </div>

    </div>

    <div class="panel panelPaymentOption paymentOptionsSection" *ngIf="bookingAmendSection !== 'booker' && bookingState.bookingDetails.bookingAmendType !== 'refund' && (bookingType !== 'amend' ? price.totalPrice.majorAmount > 0 : true)">
      <h5 class="checkoutTitle">{{appCopy.panelHeader['paymentOptionsTitle'+selectedLanguage] || 'Payment Options'}}</h5>
      <ul class="paymentMethodList list-unstyled" *ngIf="paymentOptionsAvailable.paypal">
        <li class="paymentMethodList__item">
          <div class="paymentMethodList__row" [class.paymentMethodList__row--selected]="selectedPaymentMethod === 'paypal'" (change)="selectPaymentMethod('paypal')">
            <div class="checkbox checkbox--default">
              <input type="radio" name="paymentMethodChoice" id="pmPaypal" [checked]="selectedPaymentMethod === 'paypal'">
              <label for="pmPaypal" class="paymentMethodList__label">PayPal</label>
            </div>
            <span class="paymentMethodList__brand">
              <img src="./images/PayPal.svg" alt="PayPal" height="20">
            </span>
          </div>
        </li>
        <li class="paymentMethodList__item">
          <div class="paymentMethodList__row" [class.paymentMethodList__row--selected]="selectedPaymentMethod === 'card'" (change)="selectPaymentMethod('card')">
            <div class="checkbox checkbox--default">
              <input type="radio" name="paymentMethodChoice" id="pmCard" [checked]="selectedPaymentMethod === 'card'">
              <label for="pmCard" class="paymentMethodList__label">{{appCopy.panelHeader['payWithCardLabel'+selectedLanguage] || 'Pay with card'}}</label>
            </div>
            <span class="paymentMethodList__brand">
              <i class="sprite-common sprite-common--cards-visa"></i>
              <i class="sprite-common sprite-common--cards-mastercard"></i>
              <i class="sprite-common sprite-common--cards-amex"></i>
            </span>
          </div>
        </li>
      </ul>

      <app-standard-payment #standardPaymentForm *ngIf="!userHasCards && selectedPaymentMethod === 'card'"
        [bookingState]="bookingState" [user]="user" [price]="price" [oldprice]="oldprice" [isVisible]='isVisible'
        [appCopy]="appCopy" [selectedLanguage]='selectedLanguage' [payByInvoice]="payByInvoice"
        [overridePayment]="overridePayment" [billingAddress]="billingAddress" [billingAddressValid]="billingAddressValid"
        [flightDirection]="flightDirection" [isCustomerSupport]="isCustomerSupport" (checkPromo)="checkPromo($event)"
        (handlePaymentType)="recievePaymentType($event)" [formData]="upsellFormData"
        [PaymentTypeAvailable]="paymentOptionsAvailable" [paymenttype]="paymenttype"
        [bookingAmendType]="bookingAmendType">
      </app-standard-payment>

      <app-recurring-payment #recurringPaymentForm *ngIf="userHasCards && selectedPaymentMethod === 'card'"
        [bookingState]="bookingState" [user]="user" [price]="price" [appCopy]="appCopy"
        [selectedLanguage]='selectedLanguage' [payByInvoice]="payByInvoice" [overridePayment]="overridePayment"
        (deleteSavedCard)="deleteSavedCard($event)" [billingAddress]="billingAddress"
        [billingAddressValid]="billingAddressValid" [flightDirection]="flightDirection"
        [isCustomerSupport]="isCustomerSupport" (handlePaymentType)="recievePaymentType($event)"
        [formData]="upsellFormData" [PaymentTypeAvailable]="paymentOptionsAvailable" [paymenttype]="paymenttype">
      </app-recurring-payment>
    </div>

    <div class="panel panelPaymentOption">
      <div class="row margin-bottom-8" *ngIf="!payByInvoice && bookingType !== 'amend'">

        <div class="mobileShowPromo" *ngIf="screenSize < 1024">
          <div class="col-lg-12 col-md-12">
            <app-promo [price]="price" [user]="user" [togglePromo]="togglePromo" [appCopy]="appCopy"
              [selectedLanguage]='selectedLanguage'>
            </app-promo>
          </div>

          <!--- Begin Mention Me referee placeholder div -->
          <!-- <div id="mmWrapper"
            class="col-lg-6 col-md-6 margin-top-16 margin-bottom-16 mmWrapper--link" (click)="togglePromo = true"></div> -->
          <!--- End Mention Me referee placeholder div -->
        </div>


      </div>
      <div class="row">
        <div [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'col-md-12' : 'col-md-12'">
          <!-- standard submit button-->
          <div class="margin-bottom-8 clearfix" *ngIf="bookingType !== 'amend' && bookingAmendSection !== 'booker'">

            <button id="formPayment-submit" style="background-color: #7850FA;color: white; height: 48px;" type="button"
              class="btn btn-primary btn-block tether-payment-target"
              [disabled]="
                disableBook ||
                !phoneNumberValid ||
                virtualBags===0 ||
                (paymentOptionsAvailable.paypal && !selectedPaymentMethod) ||
                (bookerForm && !bookerForm?.form?.valid) ||
                (termsForm && !termsForm?.form?.valid) ||
                (standardPaymentForm && !standardPaymentForm?.form?.valid) ||
                (standardPaymentForm && standardPaymentForm?.billingAddressForm && !standardPaymentForm?.billingAddressForm?.form?.valid) ||
                (recurringPaymentForm && !recurringPaymentForm?.form?.valid) ||
                (recurringPaymentForm && recurringPaymentForm?.billingAddressForm && !recurringPaymentForm?.billingAddressForm?.form?.valid)" value="Pay"
              (click)="handlePaymentSubmit()">
              {{appCopy.panelHeader['buttonConfirm'+selectedLanguage]}}&nbsp;
              <span *ngIf="!isD2dService" class="price_mobile_view">
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol === 'CHF'">{{
                  price.totalPrice.currencySymbol
                  + ' ' + price.totalPrice.majorAmount}}</span>
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol !== 'CHF'">{{
                  price.totalPrice.currencySymbol
                  + price.totalPrice.majorAmount }}</span>
                <div class="loader-container-btn" *ngIf="showLoader">
                  <div class="loader loader--white">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" />
                    </svg>
                  </div>
                </div>
              </span>

              {{
              logDisabledConditions()
              }}

              <span *ngIf="isD2dService" class="price_mobile_view">
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol === 'CHF'">{{
                  price.totalPrice.currencySymbol + ' ' + getD2dDiscountPrice() }}</span>
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol !== 'CHF'">{{
                  price.totalPrice.currencySymbol + getD2dDiscountPrice() }}</span>
                <div class="loader-container-btn" *ngIf="showLoader">
                  <div class="loader loader--white">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" />
                    </svg>
                  </div>
                </div>
              </span>
              &nbsp;{{appCopy.panelHeader['confirmPart2'+selectedLanguage]}}
            </button>
          </div>




          <!-- amend payment submit -->
          <div class="margin-bottom-16" *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker'">

            <button id="formPayment-submit" style="background-color: #7850FA;color: white; height: 48px;" type="button"
              class="btn btn-primary btn-block tether-payment-target"
              [disabled]="
                disableBook ||
                !phoneNumberValid ||
                (paymentOptionsAvailable.paypal && !selectedPaymentMethod && bookingState.bookingDetails.bookingAmendType !== 'refund') ||
                (standardPaymentForm && !standardPaymentForm?.form?.valid) ||
                (standardPaymentForm && standardPaymentForm?.billingAddressForm && !standardPaymentForm?.billingAddressForm?.form?.valid) ||
                (recurringPaymentForm && !recurringPaymentForm?.form?.valid) ||
                (recurringPaymentForm && recurringPaymentForm?.billingAddressForm && !recurringPaymentForm?.billingAddressForm?.form?.valid)" value="Pay"
              (click)="handlePaymentAmend('manualCardPayment')">
              <div class="loader-container-btn" *ngIf="showLoader">
                <div class="loader loader--white">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" />
                  </svg>
                </div>
              </div>
              <span
                *ngIf="bookingState.bookingDetails.bookingAmendType === 'refund'">{{appCopy.panelHeader['confirmRefund'+selectedLanguage]}}</span>
              <span
                *ngIf="bookingState.bookingDetails.bookingAmendType !== 'refund'">{{appCopy.panelHeader['buttonConfirm'+selectedLanguage]}}</span>

              <span class="price_mobile_view">

                <ng-template [ngIf]="bookingState.bookingDetails.bookingAmendType === 'refund'" [ngIfElse]="notRefund">
                  <span *ngIf="price.totalPrice.currencySymbol === 'CHF'">&nbsp;&nbsp;-&nbsp;{{
                    price.totalPrice.currencySymbol + ' ' + price.priceHistory.majorAmount}}</span>
                  <span *ngIf="price.totalPrice.currencySymbol !== 'CHF'">&nbsp;&nbsp;-&nbsp;{{
                    price.totalPrice.currencySymbol +
                    price.priceHistory.majorAmount }}</span>
                </ng-template>

                <ng-template #notRefund>
                  <ng-template [ngIf]="isFailedPayment" [ngIfElse]="amendPayment">
                    <span *ngIf="price.totalPrice.currencySymbol === 'CHF'">&nbsp;{{
                      price.totalPrice.currencySymbol + ' ' +price.totalPrice.majorAmount}}</span>
                    <span *ngIf="price.totalPrice.currencySymbol !== 'CHF'">&nbsp;{{ price.totalPrice.currencySymbol +
                      price.totalPrice.majorAmount }}</span>
                  </ng-template>

                  <ng-template #amendPayment>
                    <span *ngIf="price.totalPrice.currencySymbol === 'CHF'">&nbsp;{{
                      price.totalPrice.currencySymbol + ' ' +price.priceHistory.majorAmount}}</span>
                    <span *ngIf="price.totalPrice.currencySymbol !== 'CHF'">&nbsp;{{ price.totalPrice.currencySymbol +
                      price.priceHistory.majorAmount }}</span>
                  </ng-template>
                </ng-template>




              </span>
              &nbsp;{{appCopy.panelHeader['confirmPart2'+selectedLanguage]}}
            </button>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p *ngIf="bookingType !== 'amend' || (bookingType === 'amend' && bookingAmendSection !== 'booker')"
            class="text-caption text-dark-blue margin-top-8 margin-bottom-8"
            [innerHTML]="appCopy.termsAndConditions['content'+selectedLanguage]">
          </p>
        </div>
      </div>
      <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="text-dark-green margin-bottom-8">
        <i class="icon icon-cut-off-checkmark"></i>
        <ng-container *ngIf="collectionDiff > 12 else less12">
          {{appCopy.panelHeader['cutOfTiming'+selectedLanguage]}}
          {{cutOffTimeWindowDate | date:'MMMM d' :'' : languageCode}} {{appCopy.panelHeader['at'+selectedLanguage]}}
          {{cutOffTimeWindowTime | date:'hh:mm a' :'' : languageCode}}
        </ng-container>
        <ng-template #less12>
          {{appCopy.panelHeader['cutOfTimingLess12'+selectedLanguage]}}
        </ng-template>
      </p>

      <p *ngIf="bookingType !== 'amend' && amendCutOffTimeWindowDate && collectionDiff > 2"
        class="text-dark-green margin-bottom-8">
        <i class="icon icon-cut-off-checkmark"></i>
        {{appCopy.panelHeader['amendCutOfTiming'+selectedLanguage]}}
        {{amendCutOffTimeWindowDate | date:'MMMM d' :'' : languageCode}} {{appCopy.panelHeader['at'+selectedLanguage]}}
        {{amendCutOffTimeWindowTime | date:'hh:mm a' :'' : languageCode}}
      </p>

      <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="text-dark-green">
        <i class="icon icon-cut-off-checkmark"></i>{{' '}}
        {{appCopy.panelHeader['endorseBy'+selectedLanguage].replace('%s', bookingAirportName).replace('%s',
        bookingAirlineName)}}
      </p>

    </div>


  </div>
</div>
<div class="challengerModal" [class.active]="showChallengeShopper">
  <div class="challengerModal__container">
    <h1 *ngIf="showChallengeShopper" class="margin-bottom-32">
      {{appCopy.panelHeader['titleChallengeShopper'+selectedLanguage]}}</h1>
    <div id="threedsContainer"></div>
    <p *ngIf="showChallengeShopper" class="margin-top-24"
      [innerHTML]="appCopy.panelHeader['contentChallengeShopper'+selectedLanguage] + this.bookingState.bookingDetails.bookingReference">
    </p>
  </div>
</div>

<div *ngIf="threeDsPaymentType === 'redirect'" class='3ds1_redirection_form'>
  <form #threeDs1Form method="POST" action="{{threeDs1Data.issueUrl}}" id="3dform">
    <input type="hidden" name="PaReq" value="{{threeDs1Data.pReq}}" />
    <input type="hidden" name="MD" value="{{threeDs1Data.md}}" />
    <input type="hidden" name="TermUrl" value="{{threeDs1Data.termUrl}}" />
    <noscript>
      <br>
      <br>
      <div style="text-align: center">
        <h1>Processing your 3D Secure Transaction</h1>
        <p>Please click continue to continue the processing of your 3D Secure transaction.</p>
        <input type="submit" class="button" value="continue" />
      </div>
    </noscript>
  </form>
</div>